import { Box } from "@mantine/core";
import KineticPerimetryStimulusViewer from "@components/testContainer/common/KineticPerimetryStimulusViewer";
import { KineticPerimetryTestResult } from "types/testTypes";

export default function KineticPerimetryTestEntry({ entry }) {
  const resultData = (entry as KineticPerimetryTestResult)?.results;

  return (
    <Box style={{ padding: 20 }}>
      <Box>
        {
          <KineticPerimetryStimulusViewer
            divisionAngle={resultData?.kineticGraphStat?.angleIncrement}
            maxAngle={resultData?.kineticGraphStat?.maxAngle}
            responses={resultData?.responses}
            style={{ width: "100%", height: "100%" }}
          />
        }
      </Box>
    </Box>
  );
}
